export default {"src":"/_next/static/media/facebook-logo.ece405ee.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};